'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCookie = undefined;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _auth = require('web-fns/dist/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useCookie = exports.useCookie = function useCookie(key, options) {
    if (options === void 0) {
        options = {};
    }
    options.domain = (0, _auth.getMainDomain)(window.location.hostname);
    var setValue = function setValue(value) {
        _jsCookie2.default.set(key, value, options);
        return value;
    };
    var getValue = function getValue() {
        return _jsCookie2.default.get(key, options);
    };
    var deleteKey = function deleteKey() {
        return _jsCookie2.default.remove(key, options);
    };
    return {
        setValue: setValue,
        getValue: getValue,
        deleteKey: deleteKey
    };
};
//# sourceMappingURL=use-cookie.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/helpers/hooks/use-cookie.js
// module id = 996
// module chunks = 0